// extracted by mini-css-extract-plugin
export default {"HamburgerMenu":"HamburgerMenuStyle_HamburgerMenu__2Lbsv","line":"HamburgerMenuStyle_line__wfNyO","MenuOverlap":"HamburgerMenuStyle_MenuOverlap__N7Rv9"};